import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import ReactDOM from "react-dom";
import {closeDrawer} from "../../redux/slice/opnerSlice";
import AssetSimpleView from "../../packages/asset/mng/info/subPages/view/AssetSimpleView";

function ContentsDrawer({id, entity}) {
    const open =useSelector(state => state.opener.drawer['ContentsDrawer']||false);
    const dispatch = useDispatch();

    return (
        <>
            {ReactDOM.createPortal(
                <div>
                    {/* 드로어 회색배경 */}
                    <div className={`drawer-background ${open ? 'show' : 'none'}`} onClick={() => {
                        dispatch(closeDrawer({key: 'ContentsDrawer'}))
                    }}></div>
                    {/* 드로어 컨테이너 */}
                    <div className={`drawer-view py-[2rem] px-[1rem] ${open ? 'slide-in' : ''}`} style={{width: '600px'}}>

                        {id!==0 && entity=='asset' && <AssetSimpleView id={id} /> }
                    </div>


                    </div>
            , document.body)}
        </>
    );
}

export default ContentsDrawer;